import { Autocomplete, Box, CircularProgress, Grid, MenuItem, Paper, Step, StepConnector, StepLabel, Stepper, Typography, stepConnectorClasses, styled } from "@mui/material"
import { Fragment, memo } from "react"
import { useDispatch, useSelector } from 'react-redux'

import CustomInput from "../../components/inputs/CustomInput"
import {  USER_ROLES } from "../../utils/constants"
import { findNameByRole, getAllowedRoles, titleCase } from "../../utils/helper"
import CustomDialog from "../../components/layouts/common/CustomDialog"
import { CenteredBox } from "../../components/layouts/OneViewBox"
import SubmitButton from "../../components/button/SubmitButton"
// import DocumentFields from "./DocumentFields"
import PersonalDetailsFields from "./PersonalDetailsFields"
// import OtherDetailsFields from "./TestDetailsFields"
import TestDetailsFields from "./TestDetailsFields"
import SuggestedProducts from "./SuggestedProducts"
import OtoScopDataUi from "./OtoScopeUi"
import BeneficiaryAudioGramController from "./AudioGram/BeneficiaryAudioGramController"




const QontoConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 10,
        left: 'calc(-50% + 16px)',
        right: 'calc(50% + 16px)',
    },
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#784af4',
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: '#784af4',
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
        borderTopWidth: 3,
        borderRadius: 1,
    },
}));
const CreateUi = ({ fields, setFields, loading, step, onPreviosButtonClick, modal, fetchById }) => {
    const { user } = useSelector(state => state)
    console.log("fields", fields)
    console.log("step", step)

    return <>

        {(!fields.id && !modal) && <Typography variant="h6" sx={{ ml: 2 }}>Add Beneficiary</Typography>}
        {/* <Stepper alternativeLabel connector={<QontoConnector />} activeStep={step} >
            <Step >
                <StepLabel>Personal Details</StepLabel>
            </Step>
    
        </Stepper> */}
        {fields.err && fields.err != '' && <Typography mt={1} color="error" fontWeight="bold" mb={1} variant="body1" align="center">
            {fields.err}
        </Typography>}
        <Box sx={{ display: "flex", width: "100%", flex: 1, justifyContent: "flex-start" }} mt={3}>

            {<Grid container >

                <Grid item md={12} xs={12}  >

                    <PersonalDetailsFields show={step == 0} fields={fields} setFields={setFields} loading={loading} />
                    {/* {step == 1 && <DocumentFields show={step == 1} fields={fields} setFields={setFields} loading={loading} />} */}
                    {/* {step == 1 && <OtoScopDataUi
                        fields={fields}
                        setFields={setFields}
                        fetchFunction={fetchById}
                    />} */}
                    {/* {step == 2 && <SuggestedProducts show={step == 2} fields={fields} setFields={setFields} loading={loading} />} */}
                    {/* {step == 2 && <BeneficiaryAudioGramController show={step == 2} fields={fields} setFields={setFields} loading={loading} />} */}

                </Grid>
            </Grid>}


        </Box>


    </>
}

const CreatePage = ({ fetchById, title, modalKey, fields, setFields, loading, step,setStep, onPreviosButtonClick, onNextButtonClick,onSubmit}) => {
    return (
        <Box sx={{ display: "flex", flex: 1 }}>
            <Paper elevation={2} sx={{ width: "100%", padding: 2, paddingBottom: 0, display: "flex", flex: 1, flexDirection: "column" }} >

                <Box component="form" autoComplete="off" onSubmit={onNextButtonClick} on sx={{ width: '100%', display: "flex", flex: 1, flexDirection: "column" }} mb={3} >

                    <CreateUi
                        step={step}
                        setStep={setStep}
                        loading={loading}
                        fields={fields}
                        setFields={setFields}
                        onPreviosButtonClick={onPreviosButtonClick}
                        fetchById={fetchById}
                    />
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems:"center", }}>
                        {<Box >{step === 2 && <SubmitButton type='button' title="Back" onClick={onPreviosButtonClick} />}</Box>}
                        <Box mt={2}><SubmitButton loading={loading} type='submit' title={step == 0 ? "Submit" : ("Next" + ``)} /></Box>

                    </Box>


                </Box>
            </Paper>
        </Box>)

}

const CreateModal = memo(({ fetchById, title, modalKey, fields, setFields, loading, fetchLoading, isUpdate, step, onPreviosButtonClick, onNextButtonClick,onSubmit }) => {
    return (
        <CustomDialog
            id={modalKey}
            disableDirectClose={true}
            loading={loading || fetchLoading}
            err={fields.err}
            onSubmit={onNextButtonClick}
            title={`${isUpdate ? "Update" : "Create"} ${title}`}
            onClose={onPreviosButtonClick}
            closeText={step == 0 ? "Close" : "Back"}
            confirmText={`${(step == 0) ? (isUpdate ? "Update" : "Create") : "Next"}`}
        >
            {
                fetchLoading ? <CenteredBox sx={{ minHeight: "200px" }}><CircularProgress /></CenteredBox> :
                    <CreateUi
                        modal
                        onPreviosButtonClick={onPreviosButtonClick}
                        step={step}
                        loading={loading}
                        fields={fields}
                        setFields={setFields}
                        fetchById={fetchById}
                    />
            }
        </CustomDialog>
    )
})
export { CreateModal }
export default memo(CreatePage)